module.exports = __webpack_public_path__ + "static/img/fitness.1d6101c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fitness.jpg
// module id = FZve
// module chunks = 1